export default "__VITE_ASSET__UBenV0vL__"